// extracted by mini-css-extract-plugin
export var alternate = "_9-j";
export var black = "_9-6";
export var blue = "_9-f";
export var blueLight = "_9-e";
export var brand = "_9-8";
export var darkMode = "_9-b";
export var error = "_9-a";
export var gray = "_9-5";
export var grayBlue = "_9-d";
export var iconWrapper = "_9-3";
export var inactive = "_9-7";
export var indigo = "_9-g";
export var orange = "_9-i";
export var pink = "_9-h";
export var primary = "_9-0";
export var purple = "_9-9";
export var success = "_9-4";
export var warning = "_9-c";
export var white = "_9-1";
export var whiteSuccess = "_9-2";